export default __webpack_public_path__ + "static/media/spain.09111a44.png";